import { InvoiceWebResponse } from '@/components/Invoice/types';
import axios, { AxiosResponse } from 'axios';
import { getAirwayUrl } from '@/utils/environment';
import { InvoicePaymentStatus, InvoiceStatus } from '@/constants';

export const airwayClient = axios.create({
  baseURL: getAirwayUrl(),
});

export const getInvoice = (signature: string): Promise<AxiosResponse<InvoiceWebResponse>> =>
  airwayClient.get('/invoice', {
    headers: {
      Authorization: `Bearer ${signature}`,
    },
  });

export const getInvoiceStatus = (
  signature: string
): Promise<AxiosResponse<{ status: InvoiceStatus; paymentStatus: InvoicePaymentStatus }>> =>
  airwayClient.get('/invoice/status', {
    headers: {
      Authorization: `Bearer ${signature}`,
    },
  });
